const reveal = (className) => {
	const elements = document.querySelectorAll(className)
	elements.forEach(el => {
		el.style.opacity = "0"
	})
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			let options = {
				easing: "ease-in-out",
				duration: entry.target.dataset.duration || "700",
				delay: entry.target.dataset.delay || "0",
				animation: entry.target.dataset.animation || "reveal-bottom"
			};

			if(entry.intersectionRatio > 0 || entry.isIntersecting){
				entry.target.style.animation = `${options.animation} ${options.duration}ms ${options.delay}ms forwards ease-out`
			}else{
				// entry.target.style.animation = 'none'
			}
		})
	})
	elements.forEach(el => observer.observe(el))
}

export { reveal };
